export const CLEAR_USER = 'CLEAR_USER';
export const FETCH_USER_BY_EMAIL_SLUG_START = 'FETCH_USER_BY_EMAIL_SLUG_START';
export const FETCH_USER_BY_EMAIL_SLUG_SUCCESS =
  'FETCH_USER_BY_EMAIL_SLUG_SUCCESS';
export const FETCH_USER_BY_EMAIL_SLUG_FAILURE =
  'FETCH_USER_BY_EMAIL_SLUG_FAILURE';
export const FETCH_USER_TENANTS_BY_EMAIL_SLUG_START =
  'FETCH_USER_TENANTS_BY_EMAIL_SLUG_START';
export const FETCH_USER_TENANTS_BY_EMAIL_SLUG_SUCCESS =
  'FETCH_USER_TENANTS_BY_EMAIL_SLUG_SUCCESS';
export const FETCH_USER_TENANTS_BY_EMAIL_SLUG_FAILURE =
  'FETCH_USER_TENANTS_BY_EMAIL_SLUG_FAILURE';
export const FETCH_USER_TENANTS_SUCCESS = 'FETCH_USER_TENANTS_SUCCESS';
export const FETCH_USER_NOTIFICATIONS_SUCCESS =
  'FETCH_USER_NOTIFICATIONS_SUCCESS';
